module.exports = __webpack_public_path__ + "static/img/logo14.6ad68d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/home/logo/logo14.jpg
// module id = ljDC
// module chunks = 1